import { Component, Inject, Input, OnDestroy, OnInit, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { NavigationEnd, Router } from '@angular/router';
import { TripAdvisorCard } from '../../core/dto/trip-advisor-card.interface';
import { filter, Subscription } from 'rxjs';

@Component({
  selector: 'app-trip-advisor-card',
  template: `
    <div class="tripadvisor-shell">
      <ng-container *ngIf="useDestinationWidget; else homeWidget">
        <iframe
          src="https://cdn.trustindex.io/amp-widget.html#07b85db60f4c4841508649cd0d2"
          loading="lazy"
          title="Opiniones verificadas de viajeros sobre Signature Tours en TripAdvisor"
          sandbox="allow-scripts allow-same-origin"
          layout="fixed-height"
          width="100%"
          height="270"
          resizable="resizable"
        >
          <span overflow></span>
        </iframe>
      </ng-container>

      <ng-template #homeWidget>
        <iframe
          src="https://cdn.trustindex.io/amp-widget.html#718180e59f0124693e064b30f37"
          loading="lazy"
          title="Opiniones verificadas de viajeros sobre Signature Tours en TripAdvisor"
          sandbox="allow-scripts allow-same-origin"
          layout="fixed-height"
          width="100%"
          height="270"
          resizable="resizable"
        >
          <span overflow></span>
        </iframe>
      </ng-template>
    </div>
  `,
  styleUrls: ['./trip-advisor-card.component.scss']
})
export class TripAdvisorCardComponent implements OnInit, OnDestroy {
  @Input() card!: TripAdvisorCard

  trackByFn(index: number): number {
    return index
  }

  useDestinationWidget = false;
  private sub?: Subscription;
  private readonly isBrowser: boolean;
  private readonly destinationPrefixes: string[] = [
    '/destino/buenos-aires',
    '/destino/uruguay',
    '/buenos-aires-tours/unconventional',
    '/buenos-aires-tours/tango-shows',
    '/buenos-aires-tours/shore-excursions',
    '/buenos-aires-tours/transfers'
  ];

  constructor(
    private readonly router: Router,
    @Inject(PLATFORM_ID) platformId: object
  ) {
    this.isBrowser = isPlatformBrowser(platformId);
  }

  ngOnInit(): void {
    this.evaluateRoute(this.router.url);
    this.sub = this.router.events
      .pipe(filter(ev => ev instanceof NavigationEnd))
      .subscribe((ev: any) => this.evaluateRoute(ev.urlAfterRedirects || ev.url));

    if (!this.isBrowser) return;
  }

  ngOnDestroy(): void {
    this.sub?.unsubscribe();
  }

  private evaluateRoute(url: string): void {
    const path = (url || '').split('?')[0].split('#')[0];
    this.useDestinationWidget = this.destinationPrefixes.some(prefix =>
      path.startsWith(prefix)
    );
  }
}
